import type {PerkUsagePreviewComponentProps} from '@cohort/merchants/apps';
import {Fragment} from 'react';

export const TalonOneCouponPerkIntegrationsUsagePreviewComponent: React.FC<
  PerkUsagePreviewComponentProps
> = () => <Fragment />;
